import {IncomingMessage} from 'http';
import {QueryClient} from '@tanstack/react-query';
import {fetchQueryPromiseAll} from './fetchQueryPromiseAll';

interface PrefetchHandle {
  queryClient: QueryClient;
  req?: IncomingMessage;
}

export const initialReactQueryPrefetchList = async ({
  queryClient,
}: PrefetchHandle) => {
  await fetchQueryPromiseAll({
    queryClient,
    // TODO: @root SSR 에서 프리패치 할 API를 여기에 추가하자
    fetchQueries: [],
  });
};
